import { z } from "zod";
import { createLocalizedDateFromDateOnlyString } from "../_helpers/dateTime";
import { purchaseOrderItemMessagesSchema } from "./Messaging";

export const vendorPurchaseOrderItemSchema = z.object({
  vendorId: z.number(),
  purchaseOrderNumber: z.string(),
  purchaseOrderItemId: z.number(),
  lineItemNumber: z.number(),
  priority: z.number().nullable(),
  description: z.string(),
  quantity: z.number(),
  unitOfMeasure: z.string().nullable(),
  certificationRequired: z.boolean(),
  originalDueDate: z
    .string()
    .nullable()
    .transform((incomingDateOnlyString) =>
      incomingDateOnlyString
        ? createLocalizedDateFromDateOnlyString(incomingDateOnlyString)
        : null
    ),
  timesDueDateChanged: z.number(),
  modifiedDueDate: z.string().transform(createLocalizedDateFromDateOnlyString),
});
export type VendorPurchaseOrderItem = z.infer<
  typeof vendorPurchaseOrderItemSchema
>;

export const vendorPurchaseOrderItemsPagedSchema = z.object({
  total: z.number(),
  results: vendorPurchaseOrderItemSchema.array(),
  canChangePriority: z.boolean(),
});
export type VendorPurchaseOrderItemsPaged = z.infer<
  typeof vendorPurchaseOrderItemsPagedSchema
>;

export const vendorPurchaseOrderItemPartSchema = z.object({
  purchaseOrderItemId: z.number(),
  partNumber: z.string(),
  revision: z.string(),
  partDescription: z.string(),
  material: z.string(),
  lowRezImage: z.string().nullable().optional(),
  highRezImage: z.string().nullable().optional(),
  quantity: z.number(),
});
export type VendorPurchaseOrderItemPart = z.infer<
  typeof vendorPurchaseOrderItemPartSchema
>;

export const vendorPurchaseOrderItemPartsSchema =
  vendorPurchaseOrderItemPartSchema.array();

export type VendorPurchaseOrderItemParts = z.infer<
  typeof vendorPurchaseOrderItemPartsSchema
>;

export const purchaseOrderItemPriorityEditSchema = z.object({
  priority: z.coerce.number().gte(1).lte(2147483647).nullable().optional(),
});
export type PurchaseOrderItemPriorityEdit = z.infer<
  typeof purchaseOrderItemPriorityEditSchema
>;

export const vendorMessagePageDataSchema = z.object({
  headerData: vendorPurchaseOrderItemSchema,
  messagesData: purchaseOrderItemMessagesSchema,
});
export type VendorMessagePageData = z.infer<typeof vendorMessagePageDataSchema>;
